module.exports = __webpack_public_path__ + "img/ic_200_release.f14e033f.png";